import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { Utils } from '../../../utils/utils';
import { ResetPasswordRequestVM } from '../../../models';

@Component({
  selector: 'auth-resetpwd',
  templateUrl: './resetpwd.component.html'
})
export class ResetPasswordComponent extends BaseComponent implements OnInit {

  model: ResetPasswordRequestVM = new ResetPasswordRequestVM();
  resetPwdComplete: boolean;

  constructor(private route: ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router) {
    super(route);
    this.emitDisplayLoadingDialog(true);
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(
      r => {
        this.model.token = r['token'];
        this.verifyToken();
      },
      error => {
        this.router.navigateByUrl('/');
      }
    );

    this.myForm = this.fb.group({
      newPassword: new FormControl('', [Validators.required, Validators.pattern(this.globalSettings.passwordRules)]),
      confirmPassword: new FormControl(null, Validators.required)
    }, { validator: Utils.checkIfMatchingPasswords('newPassword', 'confirmPassword') });
  }

  verifyToken() {
    this.authService.verifyResetPwdToken(this.model.token)
      .subscribe(returnValue => {
        if (returnValue) {
          this.emitDisplayLoadingDialog(false);
        }
        else {
          this.router.navigateByUrl('/');
        }
      },
        error => {
          this.router.navigateByUrl('/');
        },
        () => { this.emitDisplayLoadingDialog(false); }
      );
  }

  onSubmit(value: string) {
    this.markAsTouched(this.myForm);
    if (this.myForm.valid) {
      this.emitDisplayLoadingDialog(true);
      this.authService.resetPassword(this.model)
        .subscribe(returnValue => {
          if (returnValue) {
            this.resetPwdComplete = true;
          }
          else {
            this.router.navigateByUrl('/');
          }
        },
        (error) => { this.emitDisplayLoadingDialog(false); },
        () => { this.emitDisplayLoadingDialog(false); }
        )
    }
  }

}
